var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIconStande20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FBFBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7501 11C20.7501 13.0711 19.0712 14.75 17.0001 14.75C14.929 14.75 13.2501 13.0711 13.2501 11C13.2501 8.92893 14.929 7.25 17.0001 7.25C19.0712 7.25 20.7501 8.92893 20.7501 11Z",
    fill: "#343634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50122 25.1182C9.57153 21.0369 12.902 17.75 17.0001 17.75C21.0983 17.75 24.4288 21.0371 24.499 25.1185C22.2162 26.166 19.6765 26.75 17.0004 26.75C14.3241 26.75 11.7842 26.1659 9.50122 25.1182Z",
    fill: "#343634"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7501 11C20.7501 13.0711 19.0712 14.75 17.0001 14.75C14.929 14.75 13.2501 13.0711 13.2501 11C13.2501 8.92893 14.929 7.25 17.0001 7.25C19.0712 7.25 20.7501 8.92893 20.7501 11Z",
    stroke: "#1E1E1E",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50122 25.1182C9.57153 21.0369 12.902 17.75 17.0001 17.75C21.0983 17.75 24.4288 21.0371 24.499 25.1185C22.2162 26.166 19.6765 26.75 17.0004 26.75C14.3241 26.75 11.7842 26.1659 9.50122 25.1182Z",
    stroke: "#1E1E1E",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconStande20);
export default __webpack_public_path__ + "static/media/User-Icon-Stande2.0.2d30e903fabfda667b9a43145adb7d21.svg";
export { ForwardRef as ReactComponent };